export default function test(str) {
    if (!str) return true;
    if (str === "") return false;
    // regexp based check, allow only digits
    return /^[a-z0-9_-]+$/.test(str);
}
